import { extractS3ObjectKeyFromUrl } from './s3';

export function extractImageHistoryItems(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.images)) return data.images;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.records)) return data.records;
  if (typeof data === 'object' && data !== null) {
    const values = Object.values(data);
    if (Array.isArray(values) && values.length && typeof values[0] === 'object') return values;
  }
  return [];
}

export function toDataUrlFromN8nBinary(maybeBinary) {
  const b = maybeBinary?.binary?.data || maybeBinary?.binary?.image || maybeBinary?.binary?.file || null;
  const base64 = b?.data;
  const mimeType = b?.mimeType || b?.mime_type || null;
  if (!base64 || typeof base64 !== 'string') return null;
  const mime = typeof mimeType === 'string' && mimeType ? mimeType : 'image/png';
  return `data:${mime};base64,${base64}`;
}

export function normalizeHistoryItem(raw, idx = 0) {
  const r0 = raw?.fields || raw;
  const r = r0?.json || r0;
  const urlCandidate =
    r?.url ||
    r?.imageUrl ||
    r?.image_url ||
    r?.generatedImageUrl ||
    r?.generated_image_url ||
    r?.resultUrl ||
    r?.result_url ||
    r?.image ||
    r?.imageDataUrl ||
    r?.dataUrl ||
    r?.data_url ||
    r?.base64 ||
    r?.imageBase64 ||
    r?.image_base64;

  const url =
    (typeof urlCandidate === 'string' && urlCandidate.startsWith('data:image'))
      ? urlCandidate
      : (typeof urlCandidate === 'string' && /^[A-Za-z0-9+/=]+$/.test(urlCandidate) && urlCandidate.length > 100)
        ? `data:image/png;base64,${urlCandidate}`
        : (typeof urlCandidate === 'string' ? urlCandidate : null) ||
          toDataUrlFromN8nBinary(r) ||
          toDataUrlFromN8nBinary(raw);

  if (!url) return null;

  const createdAt =
    r?.createdAt ||
    r?.created_at ||
    r?.timestamp ||
    r?.time ||
    r?.generatedAt ||
    r?.generated_at ||
    new Date().toISOString();

  const s3KeyCandidate =
    r?.s3Key ||
    r?.s3_key ||
    r?.s3ObjectKey ||
    r?.s3_object_key ||
    r?.objectKey ||
    r?.object_key ||
    null;

  const s3Key =
    (typeof s3KeyCandidate === 'string' && s3KeyCandidate ? s3KeyCandidate : null) || extractS3ObjectKeyFromUrl(url);

  return {
    id: String(r?.id || r?.key || r?._id || `${Date.now()}-${idx}`),
    url,
    occasion: r?.occasion || r?.event || r?.category || '',
    meme: r?.meme || r?.style || '',
    customText: r?.customText || r?.text || '',
    createdAt,
    ...(s3Key ? { s3Key } : {}),
  };
}

export function filterDeletedImages(items, deletedIds) {
  if (!Array.isArray(items) || !Array.isArray(deletedIds)) return items || [];
  return items.filter((item) => {
    if (!item || !item.id) return false;
    return !deletedIds.includes(item.id);
  });
}


